module.exports = __webpack_public_path__ + "static/media/icon_sad.6bae770e.svg";